'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import GoogleTagManager from './googleTagManager';

export default function ClientScripts({ dtmScript }) {
  useEffect(() => {
    const taScript = document.createElement('script');
    taScript.src = 'https://consent.trustarc.com/v2/notice/33ntft?pcookie';

    document.head.appendChild(taScript);

    return () => {
      taScript.remove();
    };
  }, []);
  return (
    <>
      {/* 🚨 PLEASE READ before changing scripts 🚨 */}
      {/* https://lingo-abbott.atlassian.net/wiki/spaces/BLUEBIRD/pages/3825691/Script+Strategy */}

      <GoogleTagManager />

      {/* TrustArc Autoblock */}
      <Script
        src='https://consent.trustarc.com/v2/autoblockasset/core.min.js?cmId=33ntft&pcookie'
        strategy='beforeInteractive'
      />
      <Script
        src='https://consent.trustarc.com/v2/autoblock?cmId=33ntft&pcookie'
        strategy='beforeInteractive'
      />

      {/* New Relic */}
      <Script id='newRelic' src='/uk/scripts/new-relic.js' strategy='beforeInteractive' />

      {/* Decibel  */}
      <Script src='/uk/scripts/decibelInsight.js' strategy='beforeInteractive' />

      {/* Adobe Analytics */}
      <Script src={`${dtmScript}`} async />

      <Script id='organization-structured-data' type='application/ld+json'>
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Lingo',
          url: 'https://www.hellolingo.com/uk',
          logo: 'https://www.hellolingo.com/uk/icons/lingo-logo.svg',
          sameAs: [
            'https://www.facebook.com/HelloLingo/',
            'https://www.instagram.com/hellolingo/',
            'https://www.youtube.com/@hellolingo',
          ],
        })}
      </Script>

      {/* Zendesk Chatbot */}
      <Script
        id='ze-snippet'
        src='https://static.zdassets.com/ekr/snippet.js?key=3a09021b-c2be-497d-ba95-1c4b6f2f04a2'
        async
        strategy='lazyOnload'
      />

      {/* Qualtrrics Feedback Survey */}
      <Script id='qualtrics-survey' src='/uk/scripts/qualtrics.js' strategy='lazyOnload' async />

      <Script id='scroll' src='/uk/scripts/scroll.js' strategy='beforeInteractive' />

      {/* Google Tag Script */}
      <Script id='google-tag-manager' src='/uk/scripts/google-tag.js' />
    </>
  );
}
